import React from 'react';
import AppIcon from '../ui/AppIcon';

const TermsOfService = () => {
  return (
    <div className="container">
      <div className="legal-page">
        <div className="legal-header">
          <AppIcon size={50} />
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using Nurturing Inner Love ("the Service"), you accept and agree to be 
              bound by the terms and provision of this agreement.
            </p>
          </section>

          <section>
            <h2>Description of Service</h2>
            <p>
              Nurturing Inner Love is a digital platform providing mindfulness and self-awareness content 
              including:
            </p>
            <ul>
              <li>Educational chapters on mindfulness and personal growth</li>
              <li>Interactive exercises and reflections</li>
              <li>Progress tracking and personalized recommendations</li>
              <li>Community features and support resources</li>
            </ul>
          </section>

          <section>
            <h2>User Accounts</h2>
            <p>To access certain features, you must create an account. You are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Immediately notifying us of any unauthorized use of your account</li>
              <li>Ensuring the accuracy of your account information</li>
            </ul>
          </section>

          <section>
            <h2>Subscription and Payment Terms</h2>
            <h3>Subscription Plans</h3>
            <ul>
              <li><strong>Monthly Premium:</strong> $9.99/month, billed monthly</li>
              <li><strong>Yearly Premium:</strong> $99.99/year, billed annually</li>
              <li><strong>One-time Purchase:</strong> $49.99 for lifetime premium content access</li>
            </ul>
            
            <h3>Payment Terms</h3>
            <ul>
              <li>Subscriptions automatically renew unless canceled</li>
              <li>You may cancel your subscription at any time</li>
              <li>Refunds are provided according to our refund policy</li>
              <li>One-time purchases are final and non-refundable after 30 days</li>
            </ul>
          </section>

          <section>
            <h2>Content and Intellectual Property</h2>
            <p>
              All content provided through our service, including text, exercises, audio, and visual 
              materials, is protected by copyright and other intellectual property laws.
            </p>
            <ul>
              <li>You may not copy, distribute, or modify our content without permission</li>
              <li>Content is licensed for personal, non-commercial use only</li>
              <li>We retain all rights to our proprietary content and methodology</li>
            </ul>
          </section>

          <section>
            <h2>User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Share account credentials with others</li>
              <li>Reverse engineer or attempt to extract our content or algorithms</li>
              <li>Use the service in a way that could damage or impair our servers</li>
            </ul>
          </section>

          <section>
            <h2>Disclaimer of Warranties</h2>
            <p>
              <strong>Important:</strong> Our mindfulness content is for educational purposes only and 
              is not a substitute for professional mental health treatment.
            </p>
            <ul>
              <li>The service is provided "as is" without warranties of any kind</li>
              <li>We do not guarantee specific outcomes from using our content</li>
              <li>If you have mental health concerns, please consult a qualified professional</li>
            </ul>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>
              In no event shall Nurturing Inner Love be liable for any indirect, incidental, special, 
              consequential, or punitive damages arising out of your use of the service.
            </p>
          </section>

          <section>
            <h2>Termination</h2>
            <p>
              We may terminate or suspend your account immediately, without prior notice, for conduct 
              that we believe violates these Terms of Service.
            </p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of material 
              changes via email or through our platform.
            </p>
          </section>

          <section>
            <h2>Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> legal@nurturinginnerlove.com</p>
              <p><strong>Support:</strong> support@nurturinginnerlove.com</p>
              <p><strong>Website:</strong> <a href="https://nurturinginnerlove.com">nurturinginnerlove.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
